module.exports = __webpack_public_path__ + "static/media/creditCards.c401caf0.svg";